import { Component } from 'react';
import styled from 'styled-components';
import { IBaseLayoutProps } from './IBaseLayoutProps';
import { Heading } from '../Heading/Heading';

type IStyleProps = IBaseLayoutProps;

const BaseLayoutElement = styled.div`
  display: flex;
  overflow: visible;
  padding-top: ${(props: IStyleProps) => props.paddingTop || props.padding || 0}px;
  padding-left: ${(props: IStyleProps) => props.paddingLeft || props.padding || 0}px;
  padding-right: ${(props: IStyleProps) => props.paddingRight || props.padding || 0}px;
  padding-bottom: ${(props: IStyleProps) => props.paddingBottom || props.padding || 0}px;
  transition: all 0.5s ease-in-out;
  flex: 1;
`;

const ContentElement = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${(props: IStyleProps) => (props.contentPadding != null ? props.contentPadding : 40)}px;
`;

const HeadingWrapperElement = styled.div`
  margin-bottom: 30px;
`;

const SidebarElement = styled.div`
  border-left: ${(props: IStyleProps) => (props.showSidebar ? '1px solid #f5f9fc;' : 'none')};
  max-width: ${(props: IStyleProps) => (props.showSidebar ? '400px' : '0px')};
  transition: max-width 0.5s;
  overflow: auto;
  display: flex;
  flex-direction: column;
  width: 360px;
  padding: 40px;
`;

const SidebarContentElement = styled.div`
  display: flex;
  flex-direction: column;
`;

export class BaseLayout extends Component<IBaseLayoutProps> {
  public render() {
    return (
      <BaseLayoutElement {...this.props}>
        <ContentElement contentPadding={this.props.contentPadding}>
          {(this.props.heading || this.props.subHeading) && (
            <HeadingWrapperElement>
              {this.props.heading && <Heading variation="h1">{this.props.heading}</Heading>}
              {this.props.subHeading && <Heading variation="h3">{this.props.subHeading}</Heading>}
            </HeadingWrapperElement>
          )}
          {this.props.children}
        </ContentElement>
        {(this.props.sidebar || this.props.sidebarHeading) && (
          <SidebarElement showSidebar={this.props.showSidebar}>
            {this.props.sidebarHeading && (
              <HeadingWrapperElement>
                <Heading variation="h2">{this.props.sidebarHeading}</Heading>
              </HeadingWrapperElement>
            )}
            <SidebarContentElement>{this.props.sidebar}</SidebarContentElement>
          </SidebarElement>
        )}
      </BaseLayoutElement>
    );
  }
}
